module.exports = __webpack_public_path__ + "static/media/arb graphic.d17cb2af.png";